import { VolumeOff, VolumeUp, MoreVert } from "@mui/icons-material";
import { IconButton, Menu, MenuItem, Stack } from "@mui/material";
import { Tooltip } from "components/elements/tooltip";
import { makeStyles } from "components/providers/makeStyles";
import { T } from "components/util/t";
import { useMenuState } from "hooks/useMenuState";
import { useStartSirenAudio } from "hooks/audio/useStartSirenAudio";

const useStyles = makeStyles(theme => ({
    button: {
        marginTop: theme.spacing(0.5),
        padding: theme.spacing(0.5),
    }
}));

interface AudioButtonProps {
    isMuted: boolean;
    setIsMuted: (value: boolean) => void;
}

type RemoteControlButtonsProps = AudioButtonProps;

const AudioButton: React.FC<AudioButtonProps> = ({ isMuted, setIsMuted }) => {
    const classes= useStyles();

    const handleToggle = () => {
        setIsMuted(!isMuted);
    };

    return (
        <Tooltip title={<T>{isMuted ? "Automatic siren off" : "Automatic siren on"}</T>}>
            <IconButton className={classes.button} onClick={handleToggle} aria-label="Toggle audio">
                {isMuted ? <VolumeOff /> : <VolumeUp />}
            </IconButton>
        </Tooltip>
    );
};

const MenuButton: React.FC = () => {
    const classes= useStyles();
    const [anchorEl, openMenu, closeMenu] = useMenuState();
    const { playStartSirenSound } = useStartSirenAudio();

    const handleClick = () => {
        playStartSirenSound();
    };

    return (
        <>
            <IconButton
                className={classes.button}
                aria-label="Audio menu"
                aria-controls="menu-dropdown"
                aria-haspopup="true"
                onClick={openMenu}
            >
                <MoreVert />
            </IconButton>
            <Menu
                id="menu-dropdown"
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={closeMenu}
                variant="menu"
            >
                <MenuItem data-testid={"manual-siren-menu-item"} onClick={handleClick}>
                    <T>Manual siren (1 honk)</T>
                </MenuItem>
            </Menu>
        </>
    );
};

export const RemoteControlButtons: React.FC<RemoteControlButtonsProps> = ({ isMuted, setIsMuted }) => {
    return (
        <Stack direction="row">
            <AudioButton isMuted={isMuted} setIsMuted={setIsMuted} />
            <MenuButton />
        </Stack>
    );
};
